var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasAssets
    ? _c(
        "div",
        { staticClass: "assets-analysis-table az-card-bordered mt-5" },
        [
          _c("div", { staticClass: "d-flex justify-content-between" }, [
            _c("div", { staticClass: "az-ds-card-title" }, [_vm._v("Ativos")]),
            _c(
              "div",
              { staticClass: "d-flex align-items-center az-gap" },
              [
                !_vm.hideGroupAssetsToggle
                  ? _c(
                      "div",
                      { staticClass: "assets-analysis-table__switch" },
                      [
                        _c("v-switch", {
                          attrs: {
                            dense: "",
                            "hide-details": "",
                            label: "Agrupar ativos",
                            loading: _vm.loadingAssets
                          },
                          on: { change: _vm.emitReload },
                          model: {
                            value: _vm.groupAssetsProxy,
                            callback: function($$v) {
                              _vm.groupAssetsProxy = $$v
                            },
                            expression: "groupAssetsProxy"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c("v-checkbox", {
                  staticClass: "assets-analysis-table__old-assets m-0 p-0",
                  attrs: {
                    label: "Apresentar ativos resgatados",
                    "hide-details": ""
                  },
                  model: {
                    value: _vm.showOldAssets,
                    callback: function($$v) {
                      _vm.showOldAssets = $$v
                    },
                    expression: "showOldAssets"
                  }
                }),
                _c(
                  "div",
                  { staticClass: "assets-analysis-table__search" },
                  [
                    _c("v-text-field", {
                      staticClass:
                        "assets-analysis-table__search-input new-ux no-border",
                      attrs: {
                        "hide-details": "",
                        filled: "",
                        placeholder: "Pesquisar ativo",
                        "append-icon": "mdi-magnify"
                      },
                      model: {
                        value: _vm.searchQuery,
                        callback: function($$v) {
                          _vm.searchQuery = $$v
                        },
                        expression: "searchQuery"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "assets-analysis-table__table-container mb-5" },
            [
              _c(
                "table",
                {
                  staticClass: "assets-analysis-table__table",
                  attrs: { id: "tabela-ativos-analise" }
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", {
                        staticClass: "assets-analysis-table__name-header"
                      }),
                      _vm.showOwnerColumn
                        ? _c("th", { staticClass: "text-left" }, [
                            _vm._v("Membro")
                          ])
                        : _vm._e(),
                      _c("th", [_vm._v("Saldo")]),
                      _c("th", [_vm._v("% Carteira")]),
                      _c("th", [_vm._v("% Classe")]),
                      _c("th", [_vm._v("Qtd.")]),
                      _c(
                        "th",
                        { staticClass: "assets-analysis-table__refpl-header" },
                        [_vm._v("Ref. PL")]
                      ),
                      _c(
                        "th",
                        {
                          staticClass:
                            "assets-analysis-table__rent-month-header text-dark text-left",
                          attrs: { colspan: "2" }
                        },
                        [_vm._v(" Rent Mês ")]
                      ),
                      _c(
                        "th",
                        {
                          staticClass:
                            "assets-analysis-table__rent-year-header text-dark text-left",
                          attrs: { colspan: "2" }
                        },
                        [_vm._v(" Rent Ano ")]
                      ),
                      _c(
                        "th",
                        {
                          staticClass:
                            "assets-analysis-table__rent-12m-header text-dark text-left",
                          attrs: { colspan: "2" }
                        },
                        [_vm._v(" Rent 12 meses ")]
                      ),
                      _c(
                        "th",
                        {
                          staticClass: "text-dark text-left",
                          attrs: { colspan: "3" }
                        },
                        [_vm._v("Rent início")]
                      ),
                      _c(
                        "th",
                        { staticClass: "assets-analysis-table__refcot-header" },
                        [_vm._v("Ref. Cotização")]
                      ),
                      _vm.hasAssetActionsSlot
                        ? _c(
                            "th",
                            {
                              staticClass: "assets-analysis-table__last-header"
                            },
                            [_vm._v(" Objetivo ")]
                          )
                        : _vm._e(),
                      _vm.showToggleColumn
                        ? _c("th", {
                            staticClass: "assets-analysis-table__toggle-header"
                          })
                        : _vm._e()
                    ])
                  ]),
                  _vm.hasActiveSearch && _vm.visibleGroups.length === 0
                    ? _c("tbody", [
                        _c(
                          "tr",
                          {
                            staticClass:
                              "assets-analysis-table__no-results az-text-primary az-size-14 az-muted"
                          },
                          [
                            _c(
                              "td",
                              {
                                staticClass:
                                  "assets-analysis-table__no-results-column text-center",
                                attrs: { colspan: _vm.noResultsColspan }
                              },
                              [
                                _vm._v(
                                  " Nenhum ativo encontrado para a sua pesquisa. "
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._l(_vm.visibleGroups, function(groupEntry) {
                        return _c(
                          "tbody",
                          { key: "group-" + groupEntry[0] },
                          [
                            _c(
                              "tr",
                              {
                                staticClass: "assets-analysis-table__grupo",
                                class: {
                                  "mouse-hover": _vm.canToggleGroup(
                                    groupEntry[0]
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.toggleGroupOpen(groupEntry[0])
                                  }
                                }
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "assets-analysis-table__name-group text-left"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "assets-analysis-table__group-left"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                groupEntry[0] === "total_pl"
                                                  ? "P/L Atual"
                                                  : groupEntry[0]
                                              ) +
                                              " "
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm.showOwnerColumn ? _c("td") : _vm._e(),
                                _c("td", { staticClass: "text-right" }, [
                                  _c("strong", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          groupEntry[0] === "total_pl"
                                            ? groupEntry[1]
                                            : groupEntry[1].pl || "-"
                                        ) +
                                        " "
                                    )
                                  ])
                                ]),
                                _c("td", { staticClass: "text-right" }, [
                                  _c("strong", [
                                    _vm._v(_vm._s(groupEntry[1].weight || "-"))
                                  ])
                                ]),
                                _c("td", { staticClass: "text-center" }),
                                _c("td"),
                                _c("td", {
                                  staticClass:
                                    "assets-analysis-table__refpl-group"
                                }),
                                _c("td", { staticClass: "text-center" }, [
                                  groupEntry[0] !== "total_pl"
                                    ? _c("strong", [_vm._v("%")])
                                    : _vm._e()
                                ]),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "assets-analysis-table__rent-month-group"
                                  },
                                  [
                                    groupEntry[0] !== "total_pl"
                                      ? _c("strong", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.benchmarkLabel(
                                                  groupEntry[0]
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _c("td", { staticClass: "text-center" }, [
                                  groupEntry[0] !== "total_pl"
                                    ? _c("strong", [_vm._v("%")])
                                    : _vm._e()
                                ]),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "assets-analysis-table__rent-year-group"
                                  },
                                  [
                                    groupEntry[0] !== "total_pl"
                                      ? _c("strong", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.benchmarkLabel(
                                                  groupEntry[0]
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _c("td", { staticClass: "text-center" }, [
                                  groupEntry[0] !== "total_pl"
                                    ? _c("strong", [_vm._v("%")])
                                    : _vm._e()
                                ]),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "assets-analysis-table__rent-12m-group"
                                  },
                                  [
                                    groupEntry[0] !== "total_pl"
                                      ? _c("strong", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.benchmarkLabel(
                                                  groupEntry[0]
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _c("td", { staticClass: "text-center" }, [
                                  groupEntry[0] !== "total_pl"
                                    ? _c("strong", [_vm._v("Data")])
                                    : _vm._e()
                                ]),
                                _c("td", { staticClass: "text-center" }, [
                                  groupEntry[0] !== "total_pl"
                                    ? _c("strong", [_vm._v("%")])
                                    : _vm._e()
                                ]),
                                _c("td", [
                                  groupEntry[0] !== "total_pl"
                                    ? _c("strong", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.benchmarkLabel(groupEntry[0])
                                            ) +
                                            " "
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _c("td", {
                                  staticClass:
                                    "assets-analysis-table__refcot-group"
                                }),
                                _vm.hasAssetActionsSlot
                                  ? _c("td", { staticClass: "text-center" })
                                  : _vm._e(),
                                _vm.showToggleColumn
                                  ? _c(
                                      "td",
                                      { staticClass: "text-center" },
                                      [
                                        _vm.canToggleGroup(groupEntry[0])
                                          ? _c("icon-svg", {
                                              staticClass:
                                                "assets-analysis-table__toggle-icon",
                                              attrs: {
                                                name: _vm.iconForGroup(
                                                  groupEntry[0]
                                                ),
                                                size: 16,
                                                color: "var(--secondary)",
                                                role: "button",
                                                tabindex: "0",
                                                "aria-label":
                                                  "Expandir ou recolher grupo"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.toggleGroupOpen(
                                                    groupEntry[0]
                                                  )
                                                },
                                                keydown: [
                                                  function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    ) {
                                                      return null
                                                    }
                                                    $event.stopPropagation()
                                                    return _vm.toggleGroupOpen(
                                                      groupEntry[0]
                                                    )
                                                  },
                                                  function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "space",
                                                        32,
                                                        $event.key,
                                                        [" ", "Spacebar"]
                                                      )
                                                    ) {
                                                      return null
                                                    }
                                                    $event.stopPropagation()
                                                    $event.preventDefault()
                                                    return _vm.toggleGroupOpen(
                                                      groupEntry[0]
                                                    )
                                                  }
                                                ]
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._l(_vm.getAssetsForGroup(groupEntry), function(
                              asset
                            ) {
                              return _c(
                                "tr",
                                {
                                  key: "asset-" + groupEntry[0] + "-" + asset.id
                                },
                                [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "assets-analysis-table__name-item text-left"
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "text-truncate" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: {
                                                  title: asset.nome_ativo || "-"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      asset.nome_ativo || "-"
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm.showOwnerColumn
                                    ? _c("td", { staticClass: "text-left" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(asset.membro || "-") +
                                            " "
                                        )
                                      ])
                                    : _vm._e(),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(asset.pl || "-"))
                                  ]),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(asset.weight_total || "-"))
                                  ]),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(asset.weight || "-"))
                                  ]),
                                  _c("td", { staticClass: "text-right" }, [
                                    asset.has_quantity
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "assets-analysis-table__quantity",
                                            attrs: {
                                              role: "button",
                                              tabindex: "0",
                                              title: asset.quantidade_full,
                                              "aria-label":
                                                "Copiar quantidade " +
                                                asset.quantidade_full
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.copyQuantity(asset)
                                              },
                                              keydown: [
                                                function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.copyQuantity(asset)
                                                },
                                                function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "space",
                                                      32,
                                                      $event.key,
                                                      [" ", "Spacebar"]
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  $event.preventDefault()
                                                  return _vm.copyQuantity(asset)
                                                }
                                              ]
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  asset.quantidade_display
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "assets-analysis-table__refpl-item text-center"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            asset._d_referencia_pl || "-"
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          (asset.summary &&
                                            asset.summary.mes) ||
                                            "-"
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "assets-analysis-table__rent-month-item text-center"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            (asset.summary &&
                                              asset.summary.mes_relativo) ||
                                              "-"
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          (asset.summary &&
                                            asset.summary.ano) ||
                                            "-"
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "assets-analysis-table__rent-year-item text-center"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            (asset.summary &&
                                              asset.summary.ano_relativo) ||
                                              "-"
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          (asset.summary &&
                                            asset.summary["12M"]) ||
                                            "-"
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "assets-analysis-table__rent-12m-item text-center"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            (asset.summary &&
                                              asset.summary["12M_relativo"]) ||
                                              "-"
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          (asset.summary &&
                                            asset.summary.data_inicio) ||
                                            "-"
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          (asset.summary &&
                                            asset.summary.inicio) ||
                                            "-"
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          (asset.summary &&
                                            asset.summary.inicio_relativo) ||
                                            "-"
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "assets-analysis-table__refcot-item text-center"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            asset._d_referencia_cotizacao || "-"
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _vm.hasAssetActionsSlot
                                    ? _c(
                                        "td",
                                        {
                                          staticClass:
                                            "assets-analysis-table__actions"
                                        },
                                        [
                                          _vm._t("assetActions", null, {
                                            asset: asset
                                          })
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm.showToggleColumn ? _c("td") : _vm._e()
                                ]
                              )
                            })
                          ],
                          2
                        )
                      })
                ],
                2
              )
            ]
          ),
          _vm.dataReferenceEnd
            ? _c("p", { staticClass: "mt-5 az-text-small" }, [
                _vm._v(
                  " * Data base para os ativos: " +
                    _vm._s(_vm.dataReferenceEnd) +
                    " "
                )
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }